/** Diameter of the recessed launcher slot in the navigation footer, in spacing units (4px). */
export const AI_ASSISTANT_LAUNCHER_SLOT_SIZE = 11;
